import Vue from "vue";
import { API_ROOT_STUDY_RESPONSE, studyResponse, surveys, approve, unapprove, locked, unlocked, review, unreview, revision, history, query, openQuery, replies, queryStatus, sourcedocument, document, detail, generateSource, applangaCredentials, signoff, unsignoff } from "./urls";

const studyResponseVerifyResource = Vue.resource(`${API_ROOT_STUDY_RESPONSE}${studyResponse}${surveys}{/surveyId}${revision}{revisionId}{/status}`, {}, { update: { method: "POST" } });

export function studyResponseVerify(surveyId, revisionId, status, participantId, data) {
  return studyResponseVerifyResource.save({ surveyId, revisionId, status, participantId }, data);
}

export function getStudyResponseStatus(surveyId, revisionId, status) {
  return studyResponseVerifyResource.get({ surveyId, revisionId, status });
}

const studyResponseApproveResource = Vue.resource(`${API_ROOT_STUDY_RESPONSE}${studyResponse}${surveys}{/surveyId}${revision}{revisionId}${approve}`, {}, { update: { method: "POST" } });

export function studyResponseApprove(surveyId, revisionId, participantId, data) {
  return studyResponseApproveResource.save({ surveyId, revisionId, participantId }, data);
}

const studyResponseUnapproveResource = Vue.resource(`${API_ROOT_STUDY_RESPONSE}${studyResponse}${surveys}{/surveyId}${revision}{revisionId}${unapprove}`, {}, { update: { method: "POST" } });

export function studyResponseUnapprove(surveyId, revisionId, participantId, data) {
  return studyResponseUnapproveResource.save({ surveyId, revisionId, participantId }, data);
}

const studyResponseReviewResource = Vue.resource(`${API_ROOT_STUDY_RESPONSE}${studyResponse}${surveys}{/surveyId}${revision}{revisionId}${review}`, {}, { update: { method: "POST" } });

export function studyResponseReview(surveyId, revisionId, participantId, data) {
  return studyResponseReviewResource.save({ surveyId, revisionId, participantId }, data);
}

const studyResponseUnreviewResource = Vue.resource(`${API_ROOT_STUDY_RESPONSE}${studyResponse}${surveys}{/surveyId}${revision}{revisionId}${unreview}`, {}, { update: { method: "POST" } });

export function studyResponseUnreview(surveyId, revisionId, participantId, data) {
  return studyResponseUnreviewResource.save({ surveyId, revisionId, participantId }, data);
}

const studyResponseLockResource = Vue.resource(`${API_ROOT_STUDY_RESPONSE}${studyResponse}${surveys}{/surveyId}${revision}{revisionId}${locked}`, {}, { update: { method: "POST" } });

export function studyResponseLock(surveyId, revisionId, participantId, data) {
  return studyResponseLockResource.save({ surveyId, revisionId, participantId }, data);
}

const studyResponseUnlockResource = Vue.resource(`${API_ROOT_STUDY_RESPONSE}${studyResponse}${surveys}{/surveyId}${revision}{revisionId}${unlocked}`, {}, { update: { method: "POST" } });

export function studyResponseUnlock(surveyId, revisionId, participantId, data) {
  return studyResponseUnlockResource.save({ surveyId, revisionId, participantId }, data);
}

const studyResponseSignOffResource = Vue.resource(`${API_ROOT_STUDY_RESPONSE}${studyResponse}${surveys}{/surveyId}${revision}{revisionId}${signoff}`, {}, { update: { method: "POST" } });

export function studyResponseSignOff(surveyId, revisionId, participantId, data) {
  return studyResponseSignOffResource.save({ surveyId, revisionId, participantId }, data);
}

const studyResponseUnsignoffResource = Vue.resource(`${API_ROOT_STUDY_RESPONSE}${studyResponse}${surveys}{/surveyId}${revision}{revisionId}${unsignoff}`, {}, { update: { method: "POST" } });

export function studyResponseUnsignOff(surveyId, revisionId, participantId, data) {
  return studyResponseUnsignoffResource.save({ surveyId, revisionId, participantId }, data);
}

const getStudyResponseHistoryResource = Vue.resource(`${API_ROOT_STUDY_RESPONSE}${studyResponse}${surveys}{/surveyId}${history}`, {}, { update: { method: "PUT" } });

export function getStudyResponseHistory(surveyId, participantId, studyId, trackerId) {
  return getStudyResponseHistoryResource.get({ surveyId, participantId, studyId, trackerId }, {});
}

const getStudyResponseHistoryDetailResource = Vue.resource(`${API_ROOT_STUDY_RESPONSE}${studyResponse}${surveys}{/surveyId}${revision}{revisionId}${history}${detail}`, {}, { update: { method: "PUT" } });

export function getStudyResponseHistoryDetail(surveyId, revisionId) {
  return getStudyResponseHistoryDetailResource.get({ surveyId, revisionId }, {});
}

const getSurveyResponseQueryResource = Vue.resource(`${API_ROOT_STUDY_RESPONSE}${studyResponse}${surveys}{/surveyId}${revision}{revisionId}${query}`, {}, { update: { method: "POST" } });

const getSurveyResponseOpenQueryResource = Vue.resource(`${API_ROOT_STUDY_RESPONSE}${studyResponse}${surveys}{/surveyId}${revision}{revisionId}${openQuery}`, {}, { update: { method: "GET" } });

export function postNewSurveyResponseQuery(surveyId, revisionId, participantId, data) {
  return getSurveyResponseQueryResource.save({ surveyId, revisionId, participantId }, data);
}

export function getSurveyResponseQuery(surveyId, revisionId) {
  return getSurveyResponseQueryResource.get({ surveyId, revisionId });
}

export function getSurveyResponseOpenQuery(surveyId, revisionId) {
  return getSurveyResponseOpenQueryResource.get({ surveyId, revisionId });
}

const postNewSurveyResponseQueryRepliesResource = Vue.resource(`${API_ROOT_STUDY_RESPONSE}${studyResponse}${surveys}{/surveyId}${revision}{revisionId}${replies}`, {}, { update: { method: "POST" } });

export function postNewSurveyResponseQueryReplies(surveyId, revisionId, participantId, data) {
  return postNewSurveyResponseQueryRepliesResource.save({ surveyId, revisionId, participantId }, data);
}

const updateSurveyResponseQueryStatusResource = Vue.resource(`${API_ROOT_STUDY_RESPONSE}${studyResponse}${surveys}{/surveyId}${revision}{revisionId}${queryStatus}`, {}, { update: { method: "POST" } });

export function updateSurveyResponseQueryStatus(surveyId, revisionId, participantId, data) {
  return updateSurveyResponseQueryStatusResource.save({ surveyId, revisionId, participantId }, data);
}

const getSurveyResponseSourceDocumentsResource = Vue.resource(`${API_ROOT_STUDY_RESPONSE}${studyResponse}${surveys}{/surveyId}${revision}{revisionId}${sourcedocument}`, {}, { update: { method: "POST" } });

export function postNewSurveyResponseSourceDocument(surveyId, revisionId, participantId, data) {
  return getSurveyResponseSourceDocumentsResource.save({ surveyId, revisionId, participantId }, data);
}

export function getSurveyResponseSourceDocuments(surveyId, revisionId) {
  return getSurveyResponseSourceDocumentsResource.get({ surveyId, revisionId });
}

const getSurveyResponseSourceDocResource = Vue.resource(`${API_ROOT_STUDY_RESPONSE}${studyResponse}${surveys}{/surveyId}${revision}{revisionId}/${document}{/documentId}${sourcedocument}`, {}, { update: { method: "POST" } });

export function deleteSurveyResponseSourceDocument(surveyId, revisionId, documentId, data) {
  return getSurveyResponseSourceDocResource.delete({ surveyId, revisionId, documentId }, data);
}

const getSurveyResponseResource = Vue.resource(`${API_ROOT_STUDY_RESPONSE}${studyResponse}${surveys}{/surveyId}${revision}{revisionId}`, {}, { update: { method: "POST" } });

export function updateSurveyResponse(surveyId, revisionId, data) {
  return getSurveyResponseResource.save({ surveyId, revisionId }, data);
}

const getSurveyResponseSourceDocResourceUrl = Vue.resource(`${API_ROOT_STUDY_RESPONSE}${studyResponse}${surveys}${revision}{revisionId}${generateSource}`, {}, { update: { method: "get" } });

export function getDocumentPreSignedUrlFact(revisionId, participantId) {
  return getSurveyResponseSourceDocResourceUrl.get({
    revisionId,
    participantId
  });
}

const getStudyResponseApplangaCredentials = Vue.resource(`${API_ROOT_STUDY_RESPONSE}${studyResponse}{studyId}${applangaCredentials}`, {}, { update: { method: "get" } });
export function getApplangaCredentials(studyId) {
  return getStudyResponseApplangaCredentials.get({ studyId });
}
